import React from 'react';

const MovieCard = (props) => {
    return(
        <div className="cardContainer">
           <img src={props.image} alt="" onClick={() => props.viewMovieDetails(props.movieId)}/>
           <div>
               <h2>{props.title}</h2>
            </div>
        </div>
    )
}


export default MovieCard;